export const IS_DEV = import.meta.env.MODE === 'development';
export const IS_PROD = import.meta.env.MODE === 'production';
export const IS_STAGING = import.meta.env.MODE === 'staging';
